import mongoose, { Schema } from 'mongoose';

export interface IGuest {
  type: 'adult' | 'child' | 'infant';
  title: string;
  firstName: string;
  lastName: string;
  age?: number;
}

export interface IGuestDocument extends mongoose.Document, IGuest {
  _id: never;
}

const guest = new Schema(
  {
    title: {
      // eg. Mr, Ms, Mrs
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    age: {
      type: Number,
      min: 1,
      max: 116,
    },
  },
  { _id: false },
);

export default guest;
